/** Shared Remediation Hub filter bar tokens (aligned with Configuration). */

import { ACCOUNT_DETAIL_FONT_SX } from "../../../../components/AccountDetailPolicy/accountDetailTypography";
import { HUB_ACCENT, HUB_BLUE, HUB_BORDER, HUB_MUTED, HUB_TEXT, HUB_TRACK } from "./hubTheme";

export { ACCOUNT_DETAIL_FONT_SX };
export { HUB_ACCENT, HUB_BLUE, HUB_BORDER, HUB_MUTED, HUB_TEXT, HUB_TRACK };

export const FILTER_FONT_SIZE = 13;
export const FILTER_FONT_WEIGHT = 500;
export const FILTER_POPOVER_WIDTH = 272;
export const FILTER_LIST_MAX_HEIGHT = 220;

/** Configuration-style segmented tabs. */
export const hubTabsSx = {
  minHeight: 40,
  width: "100%",
  "& .MuiTabs-flexContainer": {
    width: "100%",
    alignItems: "center",
    gap: 0.25,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    minHeight: 40,
    minWidth: "max-content",
    flexShrink: 0,
    flexGrow: { xs: 0, md: 1 },
    flexBasis: { xs: "auto", md: 0 },
    maxWidth: "none",
    px: { xs: 1, sm: 1.25 },
    fontSize: { xs: "0.75rem", md: "0.8125rem" },
    color: HUB_MUTED,
    fontWeight: 500,
    borderRadius: "8px",
    whiteSpace: "nowrap",
  },
  "& .MuiTab-root.Mui-selected": {
    color: `${HUB_TEXT} !important`,
    fontWeight: 700,
    backgroundColor: "#ffffff",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: HUB_ACCENT,
    height: 3,
    borderRadius: "2px 2px 0 0",
  },
  "& .MuiTabs-scrollButtons": {
    color: HUB_MUTED,
    "&.Mui-disabled": { opacity: 0.3 },
  },
};

export const hubTabTrackSx = {
  width: "100%",
  maxWidth: "100%",
  backgroundColor: HUB_TRACK,
  borderRadius: "10px",
  px: 0.5,
  py: 0.5,
  overflow: "hidden",
};

export const hubPageTitleSx = {
  fontWeight: 700,
  fontSize: { xs: "1.125rem", md: "1.25rem" },
  color: HUB_TEXT,
  letterSpacing: "-0.01em",
  lineHeight: 1.3,
  mb: 0.5,
};

export const filterTriggerSx = {
  textTransform: "none",
  fontSize: FILTER_FONT_SIZE,
  fontWeight: FILTER_FONT_WEIGHT,
  height: 36,
  minHeight: 36,
  flexShrink: 0,
  whiteSpace: "nowrap",
  borderRadius: "8px",
  borderColor: HUB_BORDER,
  color: HUB_TEXT,
  px: 1.5,
  boxShadow: "none",
  "& .MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: 0.75,
    color: HUB_MUTED,
  },
  "&:hover": {
    color: HUB_TEXT,
    borderColor: HUB_MUTED,
    backgroundColor: HUB_TRACK,
    boxShadow: "none",
  },
};

export const filterPopoverPaperSx = (width = FILTER_POPOVER_WIDTH) => ({
  width,
  mt: 0.5,
  borderRadius: "10px",
  border: `1px solid ${HUB_BORDER}`,
  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.08), 0 2px 4px -2px rgba(0,0,0,0.06)",
  overflow: "hidden",
  fontSize: FILTER_FONT_SIZE,
});

export const filterSearchInputSx = {
  fontSize: FILTER_FONT_SIZE,
  height: 32,
  borderRadius: "8px",
};

export const filterScrollListSx = {
  maxHeight: FILTER_LIST_MAX_HEIGHT,
  overflowY: "auto",
  py: 0.25,
  "&::-webkit-scrollbar": { width: 6 },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(0,0,0,0.18)",
    borderRadius: 3,
  },
};

export const filterListItemSx = {
  py: 0.25,
  px: 1.25,
  minHeight: 32,
  gap: 0.5,
  borderRadius: "8px",
  mx: 0.5,
  "&.Mui-selected": {
    backgroundColor: "action.selected",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "action.selected",
  },
};

export const filterListItemTextProps = {
  fontSize: FILTER_FONT_SIZE,
  lineHeight: 1.3,
  fontWeight: 400,
};

export const filterCaptionSx = {
  fontSize: 11,
  fontWeight: 400,
  color: HUB_MUTED,
};

export const filterSearchFieldSx = {
  flex: "1 1 160px",
  minWidth: 140,
  maxWidth: 280,
  width: "auto",
  "& .MuiInputBase-root": {
    fontSize: FILTER_FONT_SIZE,
    height: 36,
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  "& .MuiInputBase-input": {
    fontSize: FILTER_FONT_SIZE,
    py: 0.75,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: HUB_BORDER,
    borderRadius: "8px",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: HUB_MUTED,
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: HUB_ACCENT,
    borderWidth: 1,
  },
};

export const filterToolbarSx = {
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
  gap: 1,
  width: "100%",
  minWidth: 0,
};

export const filterTriggerLabelSx = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
  display: "block",
};

export const filterTriggerEllipsisSx = {
  maxWidth: 200,
  minWidth: 0,
  flexShrink: 1,
  overflow: "hidden",
  justifyContent: "flex-start",
};

export const filterSegmentSelectedSx = {
  backgroundColor: HUB_ACCENT,
  color: "#ffffff",
  borderColor: HUB_ACCENT,
  zIndex: 1,
  "& .MuiButton-startIcon": { color: "#ffffff" },
  "&:hover": {
    backgroundColor: HUB_ACCENT,
    color: "#ffffff",
    borderColor: HUB_ACCENT,
    filter: "brightness(0.95)",
    boxShadow: "none",
  },
};

export const filterResetButtonSx = {
  height: 36,
  minHeight: 36,
  flexShrink: 0,
  px: 2,
  borderRadius: "999px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: FILTER_FONT_SIZE,
  lineHeight: 1.2,
  boxShadow: "none",
  backgroundColor: "#1976d2",
  color: "#ffffff",
  border: "none",
  "& .MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: 0.75,
    color: "#ffffff",
  },
  "&:hover": {
    backgroundColor: "#1565c0",
    color: "#ffffff",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#90caf9",
    color: "#ffffff",
  },
};

export const filterActiveChipSx = {
  height: 26,
  fontSize: 12,
  fontWeight: 500,
  borderRadius: "8px",
  backgroundColor: HUB_TRACK,
  color: HUB_TEXT,
};

/** Apply to Remediation Hub page sections for consistent Inter 13px body. */
export const remediationHubSx = {
  ...ACCOUNT_DETAIL_FONT_SX,
  fontSize: FILTER_FONT_SIZE,
  color: HUB_TEXT,
  "& .MuiIconButton-root, & .MuiListItemButton-root, & .MuiListItemText-root": {
    fontFamily: "inherit",
  },
  "& .MuiTableCell-root": { fontSize: FILTER_FONT_SIZE, color: HUB_TEXT },
  "& .MuiTableHead-root .MuiTableCell-root": {
    fontSize: 12,
    fontWeight: 600,
    color: HUB_MUTED,
    textTransform: "none",
    letterSpacing: 0,
    backgroundColor: "#f9fafb",
  },
  "& .MuiTypography-body2": { fontSize: FILTER_FONT_SIZE },
  "& .MuiTypography-caption": { color: HUB_MUTED },
};
